import {
  setPlatformListAction,
  GET_PLATFORM_LIST,
  setAreaOptionsAction,
  GET_AREA_OPTIONS,
  setConnectedProjectCodeAction,
  GET_CONNECTED_PROJECT_CODE,
} from './reducer'
import { takeEvery, put, all, fork } from 'redux-saga/effects'
import { GET_AREA, GET_PLATFORM_FIELD } from '../../api/CommonApi'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { GET_CONNECTED_PROJECT_CODE_LIST } from '../../api/MaterialApi'

function* alltask() {
  yield takeEvery(GET_PLATFORM_LIST, getPlatform)
  yield takeEvery(GET_AREA_OPTIONS, getArea)
  yield takeEvery(GET_CONNECTED_PROJECT_CODE, getConnectedProjectCode)
}

// 平台
function* getPlatform(): any {
  const res = yield GET_PLATFORM_FIELD({
    supplierId: getSupplierId(),
  })
  if (isResponseCodeSuccess(res.code)) {
    const resdata = res.data.map((item: any) => ({
      itemFields: item.itemFields,
      name: item.orderPlatform.platformName,
      code: item.orderPlatform.platformCode,
      pushRequirements: item.orderPlatform.pushRequirements,
      showDiscountRate: item.orderPlatform.showDiscountRate,
    }))
    yield put(setPlatformListAction(resdata))
  }
}

// 区域
function* getArea(): any {
  const res = yield GET_AREA()
  if (isResponseCodeSuccess(res.code)) {
    const resdata = res.data
    yield put(setAreaOptionsAction(resdata))
  }
}

// 已对接项目编码
function* getConnectedProjectCode(): any {
  const res = yield GET_CONNECTED_PROJECT_CODE_LIST()
  if (isResponseCodeSuccess(res.code)) {
    yield put(setConnectedProjectCodeAction(res.data || []))
  } else {
    yield put(setConnectedProjectCodeAction([]))
  }
}

// 导出当前模块的saga处理方法
export default function* sagas() {
  yield all([fork(alltask)])
}
import {
  setPlatformListAction,
  GET_PLATFORM_LIST,
  setAreaOptionsAction,
  GET_AREA_OPTIONS,
  setConnectedProjectCodeAction,
  GET_CONNECTED_PROJECT_CODE,
} from './reducer'
import { takeEvery, put, all, fork } from 'redux-saga/effects'
import { GET_AREA, GET_PLATFORM_FIELD } from '../../api/CommonApi'
import { getSupplierId, isResponseCodeSuccess } from '../../tools/util'
import { GET_CONNECTED_PROJECT_CODE_LIST } from '../../api/MaterialApi'

function* alltask() {
  yield takeEvery(GET_PLATFORM_LIST, getPlatform)
  yield takeEvery(GET_AREA_OPTIONS, getArea)
  yield takeEvery(GET_CONNECTED_PROJECT_CODE, getConnectedProjectCode)
}

// 平台
function* getPlatform(): any {
  const res = yield GET_PLATFORM_FIELD({
    supplierId: getSupplierId(),
  })
  if (isResponseCodeSuccess(res.code)) {
    const resdata = res.data.map((item: any) => ({
      itemFields: item.itemFields,
      name: item.orderPlatform.platformName,
      code: item.orderPlatform.platformCode,
      pushRequirements: item.orderPlatform.pushRequirements,
      showDiscountRate: item.orderPlatform.showDiscountRate,
    }))
    yield put(setPlatformListAction(resdata))
  }
}

// 区域
function* getArea(): any {
  const res = yield GET_AREA()
  if (isResponseCodeSuccess(res.code)) {
    const resdata = res.data
    yield put(setAreaOptionsAction(resdata))
  }
}

// 已对接项目编码
function* getConnectedProjectCode(): any {
  const res = yield GET_CONNECTED_PROJECT_CODE_LIST()
  if (isResponseCodeSuccess(res.code)) {
    yield put(setConnectedProjectCodeAction(res.data || []))
  } else {
    yield put(setConnectedProjectCodeAction([]))
  }
}

// 导出当前模块的saga处理方法
export default function* sagas() {
  yield all([fork(alltask)])
}
